export default __webpack_public_path__ + "images/0xedf8b632b537d5993adb5e2e15882cd791c284cb.png";